import { Checkbox, Form, Input } from 'antd'
import DocumentUpload from 'app/components/Core/Document/Upload'
import * as React from 'react'
import { useIntl } from 'react-intl'

import { ComplainPayload } from './Modal'

const INVOICE_COMPLAIN_REASONS = {
  SINGLE_POSITION: 'single_position',
  RENTAL_PERIOD: 'rental_period',
  address: 'address',
  others: 'others'
}

type Props = {
  setPayload?: (payload: ComplainPayload) => void
  invoice: IInvoice
}

const InvoiceComplaint: React.FC<Props> = ({ invoice, setPayload }) => {
  const { formatMessage } = useIntl()

  const onValueChange = (_changed: unknown, values: { description: string; reasons: string[] }) => {
    setPayload?.({
      ...values,
      reason: values.reasons?.join(', ')
    })
  }

  return (
    <div className="fade-in-slow">
      <h5 className="text-black">{formatMessage({ id: 'invoice.modal.complaint.form.title' })}</h5>
      <p>{formatMessage({ id: 'invoice.modal.complaint.form.description' })}</p>

      <Form layout="vertical" onValuesChange={onValueChange}>
        <Form.Item name="reasons" initialValue={[]}>
          <Checkbox.Group>
            {Object.values(INVOICE_COMPLAIN_REASONS).map((value: string) => (
              <Checkbox key={value} value={value} className="d-flex ml-0 mb-1">
                {formatMessage({ id: `invoice.modal.complaint.form.option.${value}` })}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </Form.Item>
        <Form.Item
          label={formatMessage({ id: 'invoice.modal.complaint.form.annotation.label' })}
          name="description">
          <Input.TextArea
            placeholder={formatMessage({
              id: 'invoice.modal.complaint.form.annotation.placeholder'
            })}
            rows={4}
          />
        </Form.Item>
      </Form>

      <div className="mt-2">
        <DocumentUpload
          className="full-width"
          props={{
            model_id: invoice.rental_id,
            document_type: 'claim',
            model_type: 'Rental'
          }}>
          <p className="text-center text-gray my-3 p-1">
            {formatMessage({ id: 'invoice.modal.complaint.document.upload.damage' })}
          </p>
        </DocumentUpload>
      </div>
    </div>
  )
}

export default InvoiceComplaint
